import { IMapper } from "./i-mapper";
import {
  EApplicationSettingsFieldType,
  IApplicationSettingsDropdownField,
  IApplicationSettingsGroupField,
  IApplicationSettingsNumberField,
  IApplicationSettingsTextField,
  IApplicationSettingsToggleField,
  IAppSettings,
  TApplicationSettingsFieldType
} from "@zaeper/angular-application-store-lib";
import { TFieldElement } from "@zaeper/angular-dashboard-view-lib";
import { FormGroup } from "@angular/forms";
import { ApplicationSettingsTextFieldMapper } from "./settings-input-field/application-settings-text-field.mapper";
import { ApplicationSettingsNumberFieldMapper } from "./settings-input-field/application-settings-number-field.mapper";
import { ApplicationSettingsToggleFieldMapper } from "./settings-input-field/application-settings-toggle-field.mapper";
import { ApplicationSettingsDropdownFieldMapper } from "./settings-input-field/application-settings-dropdown-field.mapper";

export class AppSettingsInputFieldMapper implements Partial<IMapper<IApplicationSettingsGroupField, TFieldElement[]>> {
  constructor(private readonly _formGroup: FormGroup = new FormGroup({})) {
  }

  from(group: IApplicationSettingsGroupField): TFieldElement[] {
    return group.children.reduce((acc: TFieldElement[], curr: TApplicationSettingsFieldType): TFieldElement[] => {
      switch (curr.type) {
        case EApplicationSettingsFieldType.TEXT:
          acc.push(new ApplicationSettingsTextFieldMapper(this._formGroup).from(curr as IApplicationSettingsTextField));
          break;
        case EApplicationSettingsFieldType.NUMBER:
          acc.push(new ApplicationSettingsNumberFieldMapper(this._formGroup).from(curr as IApplicationSettingsNumberField));
          break;
        case EApplicationSettingsFieldType.TOGGLE:
          acc.push(new ApplicationSettingsToggleFieldMapper(this._formGroup).from(curr as IApplicationSettingsToggleField));
          break;
        case EApplicationSettingsFieldType.DROPDOWN:
          acc.push(new ApplicationSettingsDropdownFieldMapper(this._formGroup).from(curr as IApplicationSettingsDropdownField));
          break;
        case EApplicationSettingsFieldType.GROUP:
        case EApplicationSettingsFieldType.MULTI_SELECT:
        case EApplicationSettingsFieldType.SLIDER:
        case EApplicationSettingsFieldType.RANGE_SLIDER:
        case EApplicationSettingsFieldType.COLOR_PICKER:
        case EApplicationSettingsFieldType.FILE:
        case EApplicationSettingsFieldType.INSTALLED_APPS:
        case EApplicationSettingsFieldType.REPLICATION:
          // TODO: add renderers for the remaining field types once view-lib supports them.
          console.warn("Unsupported app settings field type", curr.type);
          break;
        default: {
          const _exhaustive: never = curr;
          console.warn("Unknown app settings field type", _exhaustive);
        }
      }
      return acc;
    }, []);
  }

  public static rootGroups(appSettings: IAppSettings): IApplicationSettingsGroupField[] {
    return appSettings.fields.filter(
      (field: TApplicationSettingsFieldType): field is IApplicationSettingsGroupField =>
        field.type === EApplicationSettingsFieldType.GROUP
    );
  }
}
